import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCalendarSetup, saveProfessionalDetails } from "../api/api";
import LeftSidebar from "../components/sidebar";
import Header from "../components/Header";
import ProfileMenu from "../components/ProfileMenu";

export default function ProfessionalProfile() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [options, setOptions] = useState({
    airlines: [],
    bases: [],
    aircrafts: [],
    roles: [],
    seats: [],
  });

  const [selected, setSelected] = useState({
    airline_uid: null,
    base_uid: null,
    aircraft_uid: null,
    role_uid: null,
    seat_uid: null,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    let mounted = true;

    getCalendarSetup()
      .then((res) => {
        if (!mounted) return;

        const data = res.data || {};
        const sel = data.selected || {};

        setSelected({
          airline_uid: sel.airline_uid || null,
          base_uid: sel.base_uid || null,
          aircraft_uid: sel.aircraft_uid || null,
          role_uid: sel.role_uid || null,
          seat_uid: sel.seat_uid || null,
        });

        setOptions(
          data.options || {
            airlines: [],
            bases: [],
            aircrafts: [],
            roles: [],
            seats: [],
          }
        );
      })
      .catch(() => setError("Failed to load professional setup"))
      .finally(() => setLoading(false));

    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (key) => (e) => {
    setSelected((prev) => ({
      ...prev,
      [key]: e.target.value || null,
    }));
  };

  const handleSaveProfessional = async () => {
    const requiredFields = [
      "airline_uid",
      "base_uid",
      "aircraft_uid",
      "role_uid",
      "seat_uid",
    ];

    for (const field of requiredFields) {
      if (!selected[field]) {
        setError("Please select all required fields");
        return;
      }
    }

    try {
      setSaving(true);
      setError("");
      setSuccess("");

      await saveProfessionalDetails({ ...selected });

      setSuccess("Professional details saved successfully!");
      setTimeout(() => navigate("/dashboard"), 1200);
    } catch {
      setError("Failed to save professional details");
    } finally {
      setSaving(false);
    }
  };

  return (
         <main className="dashboard-screen">
      <div className="container-fluid">
        <div className="row gx-5">
          <div className="col-sm-3">
           <LeftSidebar />
          </div>
          <div className="col-sm-9">
             <Header />
            <div className="row contact-section" >
              <div className="col-sm-4">
                <div className="sec1">
                  <ProfileMenu />
                </div>
              </div>
              <div className="col-sm-8">
                
                      <div className="sec2">
                        {/* <div className="card-header d-flex justify-content-between align-items-center">
                          <h4 className="mb-0">User Profile</h4>
                          <button 
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => navigate("/dashboard")}
                          >
                            Back to Dashboard
                          </button>
                        </div> */}
                        <div className="form-section">
                          <div className="row mb-3">
                            <div className="col-sm-12">
                              <h3>Set up your Professional Profile</h3>
                              <p>Change your Professional Setting</p>
                            </div>
                          </div>

              {loading && <div>Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}

              {!loading && (
                <>
                  <form className="mt-4">
                    <div className="row gy-3">

                      {/* Airline */}
                      <div className="col-md-6">
                        <label className="form-label">Airline</label>
                        <div className="select-wrapper">                          
                          <select
                            className="form-select custom-select"
                            value={selected.airline_uid || ""}
                            onChange={handleChange("airline_uid")}
                          >
                            <option value="">Airline</option>
                            {options.airlines.map((a) => (
                              <option key={a.uid} value={a.uid}>
                                {a.name} {a.iata_code && `(${a.iata_code})`}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                            
                      
                      {/* Base */}
                      <div className="col-md-6">
                       <label className="form-label">Base</label>
                        <div className="select-wrapper">
                          <select
                            className="form-select custom-select"
                            value={selected.base_uid || ""}
                            onChange={handleChange("base_uid")}
                          >
                            <option value="">Base</option>
                            {options.bases.map((b) => (
                              <option key={b.uid} value={b.uid}>
                                {b.airport_code} {b.city && `- ${b.city}`}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Aircraft */}
                      <div className="col-md-6">
                        <label className="form-label">Aircraft</label>
                        <div className="select-wrapper">
                          <select
                            className="form-select custom-select"
                            value={selected.aircraft_uid || ""}
                            onChange={handleChange("aircraft_uid")}
                          >
                            <option value="">Aircraft</option>
                            {options.aircrafts.map((ac) => (
                              <option key={ac.uid} value={ac.uid}>
                                {ac.model} {ac.manufacturer && `- ${ac.manufacturer}`}
                              </option>
                            ))}
                          </select>
                        </div>
                        
                        
                      </div>

                      {/* Role */}
                      <div className="col-md-6">
                        <label className="form-label">Role</label>
                        <div className="select-wrapper">
                            <select
                              className="form-select custom-select"
                              value={selected.role_uid || ""}
                              onChange={handleChange("role_uid")}
                            >
                              <option value="">Role</option>
                              {options.roles.map((r) => (
                                <option key={r.uid} value={r.uid}>
                                  {r.role_name}
                                </option>
                              ))}
                            </select>
                        </div>
        
                        
                      </div>

                      {/* Seat */}
                      <div className="col-md-12">
                        <label className="form-label">Seat</label>
                        <div className="select-wrapper">
                          <select
                            className="form-select custom-select"
                            value={selected.seat_uid || ""}
                            onChange={handleChange("seat_uid")}
                          >
                            <option value="">Seat</option>
                            {options.seats.map((s) => (
                              <option key={s.uid} value={s.uid}>
                                {s.seat_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        
                      </div>

                    </div>
                  </form>

                  {/* SAVE BUTTON */}
                 
                  <div className="btn-sec mt-5">
                    <button                     
                      className="btn4"                      
                    >
                      Back
                     </button>
                    <button
                      className="btn5"
                      onClick={handleSaveProfessional}
                      disabled={saving}
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div></div></div>
    </main>
  );
}
